import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { adminApi } from './api.js';

/**
 * Response overview for one survey: how many have responded, how many are still outstanding, and
 * which roster members fall in each group. It shows response *status* only — never answers — which
 * is exactly the split the anonymity guarantee allows.
 */
export function SurveyDataPage() {
  const { surveyId = '' } = useParams();
  const survey = useQuery({ queryKey: ['survey', surveyId], queryFn: () => adminApi.survey(surveyId) });
  const completion = useQuery({
    queryKey: ['survey-completion', surveyId],
    queryFn: () => adminApi.completion(surveyId),
  });

  return (
    <>
      <div className="list-header">
        <h2>{survey.data?.title || 'Survey'} responses</h2>
        <Link className="button" to="/admin">
          Back to surveys
        </Link>
      </div>

      {completion.isPending && <p>Loading…</p>}
      {completion.isError && (
        <p role="alert">Could not load response data: {completion.error.message}</p>
      )}

      {completion.data && (
        <>
          <div className="stat-row">
            <div className="stat">
              <span className="stat-number">{completion.data.completedCount}</span>
              <span className="stat-label">Total responses</span>
            </div>
            <div className="stat">
              <span className="stat-number">{completion.data.outstandingEmails.length}</span>
              <span className="stat-label">Yet to respond</span>
            </div>
            <div className="stat">
              <span className="stat-number">{completion.data.rosterSize}</span>
              <span className="stat-label">On employee list</span>
            </div>
          </div>

          <div className="respondent-columns">
            <section>
              <h3>Responded ({completion.data.completedEmails.length})</h3>
              {completion.data.completedEmails.length === 0 ? (
                <p className="muted">Nobody has responded yet.</p>
              ) : (
                <ul className="respondent-list">
                  {completion.data.completedEmails.map((email) => (
                    <li key={email}>{email}</li>
                  ))}
                </ul>
              )}
            </section>

            <section>
              <h3>Not responded ({completion.data.outstandingEmails.length})</h3>
              {completion.data.outstandingEmails.length === 0 ? (
                <p className="muted">Everyone on the employee list has responded.</p>
              ) : (
                <ul className="respondent-list">
                  {completion.data.outstandingEmails.map((email) => (
                    <li key={email}>{email}</li>
                  ))}
                </ul>
              )}
            </section>
          </div>
        </>
      )}
    </>
  );
}
